import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProductGrid from '@features/search/ProductGrid';
import Pagination from '@features/search/Pagination';

const SearchPage: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get('q') || '';
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 12;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-5 text-base">
        <span className="text-gray-500">Home &gt; </span>
        <span className="text-yellow-400">Search</span>
      </div>

      <h1 className="heading-primary mb-8">
        Search results: {query}
      </h1>

      <ProductGrid 
        currentPage={currentPage} 
        categoryId={null}
        onTotalItemsChange={setTotalItems} 
      />
      
      <Pagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
};

export default SearchPage;